export default __webpack_public_path__ + "static/media/220_it.3c716dbc.xls";